import React, { useState } from "react";
import { CheckCircle2, XCircle, Clock, ChevronDown, ChevronRight } from "lucide-react";
import { Checkbox } from "@shadcn-in-nx/ui/checkbox";
import { useTranslation } from "react-i18next";
import TestingCaseDetail from "./TestingCaseDetail";

const STATUS_ICONS = {
    passed: <CheckCircle2 className="w-4 h-4 text-green-500" />,
    failed: <XCircle className="w-4 h-4 text-red-500" />,
    running: <Clock className="w-4 h-4 text-blue-500 animate-pulse" />,
};

function TestingCaseItem({ testCase, isSelected, onToggle, isRunning }) {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);

    const duration = testCase.lastRunDuration
        ? `${(testCase.lastRunDuration / 1000).toFixed(1)}s`
        : "";

    return (
        <div>
            <div
                className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer"
                onClick={() => setExpanded(!expanded)}
            >
                <div onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        checked={isSelected}
                        onCheckedChange={onToggle}
                        disabled={isRunning}
                    />
                </div>
                {STATUS_ICONS[testCase.lastRunStatus] || (
                    <div className="w-4 h-4 rounded-full border-2 border-gray-300" />
                )}
                <div className="flex-1 min-w-0">
                    <span className="text-sm font-medium text-gray-900 truncate block">
                        {testCase.name}
                    </span>
                    {testCase.pageName && (
                        <span className="text-xs text-gray-500">
                            {testCase.pageName}
                        </span>
                    )}
                </div>
                {duration && (
                    <span className="text-xs text-gray-400">{duration}</span>
                )}
                {testCase.generatedBy === "ai" && (
                    <span className="text-xs px-1.5 py-0.5 bg-purple-50 text-purple-600 rounded">
                        AI
                    </span>
                )}
                {expanded ? (
                    <ChevronDown className="w-4 h-4 text-gray-400" />
                ) : (
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                )}
            </div>
            {expanded && <TestingCaseDetail testCase={testCase} />}
        </div>
    );
}

export default TestingCaseItem;
